<mat-form-field>
    <mat-label>{{ 'forms.applicant-tracker.streetAddress' | appTranslate }}</mat-label>
    <input
        matInput
        appAddressAutoComplete
        id="address-search-capable"
        type="text"
        placeholder=" "
        name="street_address"
        [value]="addressToRender"
        (onAddressChange)="handleAddressChange($event)"
        (blur)="handleBlur()"
        (input)="handleChange($event.target.value)"
    />
    <mat-hint>{{ 'forms.applicant-tracker.enterStreetAddressHint' | appTranslate }}</mat-hint>
</mat-form-field>
